import React from "react";

import {
  IonContent,
  //   IonHeader,
  //   IonItemDivider,
  //   IonItemGroup,
  //   IonLabel,
  //   IonMenu,
  //   IonPage,
  //   IonRouterOutlet,
  //   IonSplitPane,
  //   IonTitle,
  //   IonToolbar,
} from "@ionic/react";
import { connect } from "react-redux";
import VersionNumber from "components/VersionNumber";
// import FrontendMenu from "../components/Menu/FrontendMenu";

interface Props {
  user: any;
  children: any;
}

const FrontendLayout: React.FC<Props> = ({ user, children }) => {
  return (
    <IonContent id="main-content">
      {children}
      <VersionNumber />
    </IonContent>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.userDetails,
});

export default connect(mapStateToProps, {})(FrontendLayout);
